<template>
  <section class="pageContact">
    <h1 class="pageContact__title">Контакты</h1>
    <div class="pageContact__content">
      <h3 class="pageContact__content--title">О компании</h3>
      <div class="pageContact__content--group">
        <div class="pageContact__content--name">Полное фирменное наименование</div>
        <div class="pageContact__content--text">Общество с ограниченной ответственностью «ПЕТЕРСЕРВИС СПЕЦТЕХНОЛОГИИ»</div>
      </div>
      <div class="pageContact__content--group">
        <div class="pageContact__content--name">Сокращенное фирменное наименование</div>
        <div class="pageContact__content--text">ООО «ПС СТ»</div>
      </div>
      <div class="pageContact__content--group">
        <div class="pageContact__content--name">Место нахождения:</div>
        <div class="pageContact__content--text">
          115191, г. Москва, Холодильный переулок, дом 3, здание «Гончар», этаж 2, офис&nbsp;14
        </div>
      </div>
      <div class="pageContact__content--group">
        <div class="pageContact__content--name">Почтовый адрес:</div>
        <div class="pageContact__content--text">
          115191, г. Москва, Холодильный переулок, дом 3, здание «Гончар», этаж 2, офис&nbsp;14
        </div>
      </div>
      <div class="pageContact__content--group">
        <span class="pageContact__content--name">ОГРН: </span>
        <span class="pageContact__content--text">1127847298842</span>
      </div>
      <div class="pageContact__content--group">
        <span class="pageContact__content--name">ИНН: </span>
        <span class="pageContact__content--text">7841465198 </span>
        <span class="pageContact__content--name">КПП: </span>
        <span class="pageContact__content--text">772501001 </span>
      </div>
      <div class="pageContact__content--group">
        <span class="pageContact__content--name">ОКВЭД основной: </span>
        <span class="pageContact__content--text">62.0</span>
      </div>
      <div class="pageContact__content--group">
        <span class="pageContact__content--name">ОКПО: </span>
        <span class="pageContact__content--text">03398641</span>
      </div>
      <hr class="pageContact__content--line">
      <h3 class="pageContact__content--title small">Банковские реквизиты:</h3>
      <p class="pageContact__content--text big">
        р/с № 40702810170010007065 в Московском <br>
        Филиале АО КБ «Модульбанк» <br>
        к/c 30101810645250000092 <br>
        БИК 044525092
      </p>
      <a href="https://static.ofd.ru/ofdru/docs/%D0%9A%D0%B0%D1%80%D1%82%D0%BE%D1%87%D0%BA%D0%B0_%D0%9E%D0%9E%D0%9E_%D0%9F%D0%A1_%D0%A1%D0%A2_2021.pdf" target="_blank" class="pageContact__content--link">
        <div class="pageContact__content--linkImg">
          <img src="./assets/pdf.png" srcset="./assets/pdf@2x.png 2x" width="53" height="53" loading="lazy" alt="pdf">
        </div>
        <div class="pageContact__content--linkDesc"><span class="pageContact__content--linkGray">Скачать карточку</span> компании
          <span class="nowrap">ООО «РЕНТА»</span></div>
      </a>
      <a href="https://yandex.ru/maps/213/moscow/house/kholodilny_pereulok_3/Z04YcAVlSkwAQFtvfXtxeX9qYA==/?indoorLevel=1&ll=37.625396%2C55.708394&z=17" target="_blank" class="pageContact__content--link">
        <div class="pageContact__content--linkImg">
          <img src="./assets/map.png" srcset="./assets/map@2x.png 2x" width="59" height="64" loading="lazy" alt="map">
        </div>
        <div class="pageContact__content--linkDesc">
          Наш офис на карте <br>
          <span class="pageContact__content--linkGray">Посмотреть</span>
        </div>
      </a>

    </div>
  </section>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

<style src="./component.scss" scoped lang="scss"/>
